var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 2.99992H15.8332V1.33325H14.1665V2.99992H5.83317V1.33325H4.1665V2.99992H3.33317C2.4165 2.99992 1.6665 3.74992 1.6665 4.66658V17.9999C1.6665 18.9166 2.4165 19.6666 3.33317 19.6666H16.6665C17.5832 19.6666 18.3332 18.9166 18.3332 17.9999V4.66658C18.3332 3.74992 17.5832 2.99992 16.6665 2.99992ZM16.6665 17.9999H3.33317V8.83325H16.6665V17.9999ZM16.6665 7.16658H3.33317V4.66658H16.6665V7.16658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.639f76ad14b1e75853849894742b305b.svg";
export { ForwardRef as ReactComponent };